import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Stack, ThemeProvider } from '@mui/material';
import { denseDataGridTheme } from '../../../../cosmetics/Themes/DenseDataGrid';
import { PeriodRecent } from '../../../../hooks/useModularTimePeriodSelector';
import { DisplayMode } from './useNWDataTable';
import { useNWGatewayDataTable } from './useNWGatewayDataTable';
const debug = process.env.REACT_APP_DEBUG && false;
export const useSingleGatewayNWDataTableView = ({ gateway, initialDuration, initialRangeUnit, }) => {
    const { Table, TimePeriodComponents, PeriodOrRecent, deviceMessages } = useNWGatewayDataTable({
        selectedGateway: [gateway],
        initialDisplayMode: DisplayMode.LIVE_AND_QUERY,
        initialDuration,
        initialRangeUnit,
    });
    const { periodOrRecentRadio, shiftEarlierBtn, fromPicker, toPicker, shiftLaterBtn, resetToNowBtn, periodField, rangeUnitRadio } = TimePeriodComponents;
    const PeriodStack = (_jsxs(Stack, { direction: "row", justifyContent: "center", gap: 1, children: [periodOrRecentRadio, shiftEarlierBtn, fromPicker, toPicker, shiftLaterBtn, resetToNowBtn] }));
    const RecentStack = (_jsxs(Stack, { direction: "row", justifyContent: "center", gap: 1, children: [periodOrRecentRadio, periodField, rangeUnitRadio] }));
    const TimeStack = PeriodOrRecent === PeriodRecent.PERIOD ? PeriodStack : RecentStack;
    return {
        Table: (_jsxs(Stack, { width: "100%", gap: 1, children: [_jsx(Stack, { direction: "row", alignItems: "center", gap: 1 }), _jsx(ThemeProvider, { theme: denseDataGridTheme, children: Table })] })),
        deviceMessages,
    };
};
